import React from 'react';
import {
  CheckCircle as CheckCircleIcon,
  Schedule as ScheduleIcon,
  Block as BlockIcon,
  PlayArrow as PlayArrowIcon,
  PictureAsPdf as PdfIcon,
  Article as WordIcon,
  TableChart as ExcelIcon,
  Slideshow as PowerPointIcon,
  TextFields as TextIcon,
  Archive as ArchiveIcon,
  Code as CodeIcon,
  DataObject as JsonIcon,
  AttachFile as FileIcon,
} from '@mui/icons-material';
import {TaskStatus} from '../../../../../services/openapi/models/TaskStatus';

export const getStatusIcon = (status?: TaskStatus): React.ReactElement => {
  switch (status) {
    case TaskStatus.COMPLETED:
      return React.createElement(CheckCircleIcon);
    case TaskStatus.IN_PROGRESS:
      return React.createElement(PlayArrowIcon);
    case TaskStatus.ARCHIVED:
      return React.createElement(BlockIcon);
    case TaskStatus.OPEN:
      return React.createElement(ScheduleIcon);
    case TaskStatus.BLOCKED:
        return React.createElement(BlockIcon);  
    default:
      return React.createElement(ScheduleIcon);
  }
};

export const getStatusColor = (
  status?: TaskStatus
): 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' => {
  switch (status) {
    case TaskStatus.COMPLETED:
      return 'success';
    case TaskStatus.IN_PROGRESS:
      return 'primary';
    case TaskStatus.ARCHIVED:
      return 'default';
    case TaskStatus.OPEN:
        return 'info';
    case TaskStatus.BLOCKED:
      return 'error';
    default:
      return 'warning';
  }
};

export const getStatusLabel = (status?: TaskStatus): string => {
  switch (status) {
    case TaskStatus.COMPLETED:
      return 'Abgeschlossen';
    case TaskStatus.IN_PROGRESS:
      return 'In Bearbeitung';
    case TaskStatus.ARCHIVED:
      return 'Archiviert';
    case TaskStatus.OPEN:
      return 'Offen';
    case TaskStatus.BLOCKED:
      return 'Blockiert';
    default:
      return 'Offen';
  }
};

export const getDocumentIcon = (mimeType: string, filename?: string): React.ReactElement => {
  if (mimeType?.includes('pdf')) return React.createElement(PdfIcon);
  if (mimeType?.includes('word') || filename?.endsWith('.doc') || filename?.endsWith('.docx'))
    return React.createElement(WordIcon);
  if (mimeType?.includes('excel') || filename?.endsWith('.xls') || filename?.endsWith('.xlsx'))
    return React.createElement(ExcelIcon);
  if (mimeType?.includes('powerpoint') || filename?.endsWith('.ppt') || filename?.endsWith('.pptx'))
    return React.createElement(PowerPointIcon);
  if (mimeType?.includes('text')) return React.createElement(TextIcon);
  if (mimeType?.includes('zip') || mimeType?.includes('rar') || mimeType?.includes('7z'))
    return React.createElement(ArchiveIcon);
  if (mimeType?.includes('json')) return React.createElement(JsonIcon);
  if (mimeType?.includes('xml')) return React.createElement(CodeIcon);
  return React.createElement(FileIcon);
};

export const getDocumentIconString = (mimeType: string, filename?: string): string => {
  if (mimeType?.includes('pdf')) return '📄';
  if (mimeType?.includes('word') || filename?.endsWith('.doc') || filename?.endsWith('.docx'))
    return '📝';
  if (mimeType?.includes('excel') || filename?.endsWith('.xls') || filename?.endsWith('.xlsx'))
    return '📊';
  if (mimeType?.includes('powerpoint') || filename?.endsWith('.ppt') || filename?.endsWith('.pptx'))
    return '📽️';
  if (mimeType?.includes('text')) return '📃';
  if (mimeType?.includes('zip') || mimeType?.includes('rar') || mimeType?.includes('7z'))
    return '🗜️';
  if (mimeType?.includes('json')) return '🔧';
  if (mimeType?.includes('xml')) return '🏷️';
  return '📎';
};
